import { DataBean } from "../../DataBean";


export class ImportHealthEntity extends DataBean {


    public async importHealthEntityCatalog(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importHealthEntityCatalog_String_String_String", [filename, directory, dataStore]);
    }

}